import classNames from 'classnames';

import type { SizePaddingClassName } from './types';
import type { Argument } from 'classnames';

export const verticalFirstColShadowClassName =
  'first:sticky first:left-0 first:shadow-right first:z-10 bg-clip-padding';

export const verticalLastColShadowClassName =
  'last:absolute last:px-xs last:flex last:items-center last:align-center last:right-0 last:shadow-left last:bg-inherit bg-clip-padding';

export const makeCommonRowClassName = (isRowClickable: boolean): string =>
  classNames('bg-inherit relative', {
    'cursor-pointer': isRowClickable,
  });

export const sizePaddingColumnClassName: { [key in SizePaddingClassName]: Argument[] } = {
  sm: ['px-xs py-xxs whitespace-nowrap'],
  md: ['px-xs h-xxl first:pl-md last:pr-md whitespace-nowrap'], // TODO: Remove h-xxl after validating with design team
};

export const alignColumnClassName = (align?: string): Argument[] => {
  switch (align) {
    case 'start':
      return ['text-left', 'justify-start'];
    case 'end':
      return ['text-right', 'justify-end'];
    case 'center':
      return ['text-center', 'justify-center'];
    default:
      return [];
  }
};

export const columnClassName = classNames(
  'align-middle',
  sizePaddingColumnClassName,
  'border-t',
  'text-b3 whitespace-nowrap bg-inherit',
);
